/** @typedef {import('@basqet-dashboard/common/types/payout').PayoutTransaction} PayoutTransaction */
/** @typedef {import('@basqet-dashboard/common/types/payout').PayoutWalletAddress} PayoutWalletAddress */
/** @typedef {import('@basqet-dashboard/common/types/payout').PayoutFeeResponse} PayoutFeeResponse */
/** @typedef {import('@basqet-dashboard/common/types/payout').SinglePayoutPayload} SinglePayoutPayload */
/** @typedef {import('@basqet-dashboard/common/types/payout').BulkPayoutPayload} BulkPayoutPayload */
/** @typedef {import('@basqet-dashboard/common/types/models').Wallet} Wallet */
/** @typedef {import('@basqet-dashboard/common/types/api').PaginatedResponse} PaginatedResponse */
/** @typedef {import('@basqet-dashboard/common/types/api').PaginationParams} PaginationParams */
/** @typedef {import('@basqet-dashboard/common/types/api').ApiResponse} ApiResponse */

import { API_LIMIT, instance } from '@basqet-dashboard/common/config/api';

/**
 * @param {PaginationParams} params
 * @returns {Promise<PaginatedResponse<PayoutTransaction>>}
 */
const fetchPayouts = async ({ offset, searchQuery, status, dateFilter }) => {
  const { from, to } = dateFilter;
  const { data } = await instance.get(
    `payout/transaction?limit=${API_LIMIT}${offset ? '&offset=' + offset : ''}${
      searchQuery ? '&search_term=' + searchQuery : ''
    }${status ? '&status=' + status : ''}${from && to ? '&from=' + from + '&to=' + to : ''}`
  );
  return data;
};

/** @returns {Promise<ApiResponse<PayoutWalletAddress[]>>} */
const fetchPayoutReceiveWallets = async () => {
  const { data } = await instance.get('payout/wallet_address');
  return data;
};

/** @returns {Promise<ApiResponse<Wallet[]>>} */
const fetchPayoutWallets = async () => {
  const { data } = await instance.get('payout/wallet');
  return data;
};

/**
 * @param {SinglePayoutPayload} body
 * @returns {Promise<ApiResponse<PayoutTransaction>>}
 */
const singlePayout = async (body) => {
  const { data } = await instance.post('payout/initiate_single_payout', body);
  return data;
};

/**
 * @param {BulkPayoutPayload} body
 * @returns {Promise<ApiResponse<object>>}
 */
const bulkPayout = async (body) => {
  const { data } = await instance.post('payout/initiate_bulk_payout', body);
  return data;
};

/**
 * @param {{ amount: number, currency_id: number }} params
 * @returns {Promise<ApiResponse<PayoutFeeResponse>>}
 */
const fetchPayoutFee = async ({ amount, currency_id }) => {
  const { data } = await instance.get(`payout/fee?amount=${amount}&currency_id=${currency_id}`);
  return data;
};

/**
 * @param {{ label: string }} params
 * @returns {Promise<ApiResponse<PayoutFeeResponse>>}
 */
const fetchBulkPayoutFee = async ({ label }) => {
  const { data } = await instance.get(`payout/fee?label=${label}`);
  return data;
};

/**
 * @param {{ address: string, currency_id: number, network: string }} body
 * @returns {Promise<ApiResponse<object>>}
 */
const verifyWalletAddress = async (body) => {
  const { data } = await instance.post(`payout/wallet_address/validate`, body);
  return data;
};

export {
  bulkPayout,
  fetchBulkPayoutFee,
  fetchPayoutFee,
  fetchPayoutReceiveWallets,
  fetchPayouts,
  fetchPayoutWallets,
  singlePayout,
  verifyWalletAddress
};
